import { typedAction } from 'store/modules/base';

export interface State {
  id: string;
  codigoExterno: string;
}

export const initialState: State = {
  id: '',
  codigoExterno: '',
};

export const updateId = (emissorId: string) => {
  return typedAction('cra/emissor/UPDATE_ID', emissorId);
};

export const updateCodigoExterno = (codigoExterno: string) => {
  return typedAction('cra/emissor/UPDATE_CODIGO', codigoExterno);
};

export const resetEmissor = () => {
  return typedAction('cra/emissor/RESET');
};

export type EmissorAction = ReturnType<typeof updateId | typeof updateCodigoExterno | typeof resetEmissor>;
